import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import { formatErrorMessage } from '../../util/helpers/registerRejectErrorCodeHelper';

import {
  getCountriesRequest,
  getCountryStatesRequest,
  getAllStates,
  getAllCountries,
} from '../../request/commonRequests';
import {
  getCountriesSuccess,
  getCountriesError,
  getStatesSuccess,
  getStatesError,
  getClientStatesError,
  getClientStatesSuccess,
  getClientCountriesSuccess,
  getClientCountriesError,
} from '../actions/common/commonActions';
import {
  GET_COUNTRIES,
  GET_STATES,
  CLIENT_STATES,
  CLIENT_COUNTRIES,
} from '../actions/common/commonConstants';

function* fetchCountries({ payload }) {
  try {
    const { data } = yield call(getCountriesRequest, payload);
    yield put(getCountriesSuccess(data));
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getCountriesError(errMsg));
  }
}

function* fetchStates({ payload }) {
  try {
    const { data } = yield call(getCountryStatesRequest, payload);
    yield put(getStatesSuccess(data));
    yield put(getStatesError(''));
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getStatesError(errMsg));
  }
}

function* fetchAllStates() {
  try {
    const { data } = yield call(getAllStates);
    yield put(getClientStatesSuccess(data));
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getClientStatesError(errMsg));
  }
}
function* fetchAllCountries() {
  try {
    const { data } = yield call(getAllCountries);
    yield put(getClientCountriesSuccess(data));
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getClientCountriesError(errMsg));
  }
}

export default function* commonSaga() {
  return yield all([
    takeLatest(GET_COUNTRIES, fetchCountries),
    takeLatest(GET_STATES, fetchStates),
    takeLatest(CLIENT_STATES, fetchAllStates),
    takeLatest(CLIENT_COUNTRIES, fetchAllCountries),
  ]);
}
